import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { adminMainUrl } from "../../../../../Config";
import Cookies from "js-cookie";

const TaxDetailsEdit = ({ LedgerAccountDetail, refreshLedger }) => {


    const [tdsCategoryName, setTDSCategoryName] = useState([])
    const [isSubmitting, setIsSubmitting] = useState(false);

    const formik = useFormik({
        initialValues: {
            tds_applicable: "",
            tds_category: "",
            tds_percentage: "",
            pan_number: ""
        },
        onSubmit: async (values) => {
            setIsSubmitting(true);
            // console.log(updatedRes);
            try {
                const response = await fetch(
                    `${adminMainUrl}/api/account/update-ledger-account-tax-details`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "auth-token": Cookies.get("token"),
                            user_id: Cookies.get("flexichain_user_id"),
                        },
                        body: JSON.stringify(values),
                    }
                );

                const data = await response.json();

                if (response.ok) {
                    toast.success(data?.msg || "Ledger account updated successfully");
                    refreshLedger(LedgerAccountDetail.id)
                } else {
                    toast.error(data?.msg || "Failed to update ledger account");
                }
            } catch (error) {
                toast.error("Something went wrong. Please try again.");
            } finally {
                setIsSubmitting(false);
            }
        }
    });

    useEffect(() => {
        axios.get(`${adminMainUrl}/api/account/tds-category-name`)
            .then((res) => {
                if (res?.data?.data) {
                    setTDSCategoryName(res.data.data)
                } else {
                    setTDSCategoryName([])
                }
            })
    }, [])

    useEffect(() => {
        if (LedgerAccountDetail && LedgerAccountDetail.ledger_account_tax_details && LedgerAccountDetail.ledger_account_tax_details.length) {
            let tax_detail = LedgerAccountDetail.ledger_account_tax_details[0]
            formik.setFieldValue("ledger_account_id", LedgerAccountDetail.id)
            formik.setFieldValue("tds_applicable", tax_detail.tds_applicable);
            formik.setFieldValue("tds_category", tax_detail.tds_category);
            formik.setFieldValue("tds_percentage", tax_detail.tds_percentage);
            formik.setFieldValue("pan_number", tax_detail.pan_number);
        }
    }, [LedgerAccountDetail])


    return (
        <>
            <div className="row">
                {/* tds_applicable */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-medium">TDS Applicable</label>
                    <select
                        onChange={formik.handleChange}
                        value={formik.values.tds_applicable}
                        name="tds_applicable"
                        className="form-select bg-light padding-pt-9"
                    >
                        <option value="">Select TDS Applicable</option>
                        <option value="YES">YES</option>
                        <option value="NO">NO</option>
                    </select>
                </div>

                {/* tds_category */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-medium">
                        TDS Category <span className="text-danger">*</span>
                    </label>
                    <select
                        onChange={formik.handleChange}
                        value={formik.values.tds_category}
                        name="tds_category"
                        className="form-select bg-light padding-pt-9"
                        disabled={
                            formik.values.tds_applicable !== "YES"
                        }
                    >
                        <option value="">Select TDS Category</option>
                        {tdsCategoryName?.map((item, i) => (
                            <option key={i} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                </div>

                {/* tds_percentage */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-medium">
                        TDS Percentage <span className="text-danger">*</span>
                    </label>
                    <input
                        type="number"
                        name="tds_percentage"
                        className="form-control bg-light"
                        placeholder="e.g. 10.00"
                        onChange={formik.handleChange}
                        value={formik.values.tds_percentage || ""}
                        disabled={formik.values.tds_applicable !== "YES"}
                        min="0"
                        max="100"
                        step="1"
                    />
                </div>

                {/* pan_number */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-medium">
                        Pan Number <span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        name="pan_number"
                        className="form-control bg-light"
                        placeholder="XXXXX#####X"
                        onChange={formik.handleChange}
                        value={formik.values.pan_number}
                        // disabled={ledgerFormData.tds_applicable !== "YES"}
                        maxLength={10}
                    />

                    {/* Submit */}
                    <div className="d-flex gap-2 mt-4">
                        <button
                            type="button"
                            onClick={formik.handleSubmit}
                            className="btn btn-primary px-4"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? "Saving..." : "Save & Next"}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TaxDetailsEdit